import { render, staticRenderFns } from "./VideoExample.vue?vue&type=template&id=87e7d6ea&scoped=true"
import script from "./VideoExample.vue?vue&type=script&lang=js"
export * from "./VideoExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e7d6ea",
  null
  
)

export default component.exports